import React from 'react';
import './CourseBuilderSkeleton.css';

const CourseBuilderSkeleton = () => {
  return (
    <div className="course-builder-skeleton">
      <div className="skeleton-dashboard">
        <div className="skeleton-header">
          <div className="skeleton-title"></div>
          <div className="skeleton-subtitle"></div>
        </div>
        <div className="skeleton-grid">
          <div className="skeleton-card"></div>
          <div className="skeleton-card"></div>
          <div className="skeleton-card"></div>
        </div>
      </div>
    </div>
  );
};

export default CourseBuilderSkeleton;
